import React, { useState } from "react";
import { Button, Checkbox, Form, Input, Select, Upload, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import { InboxOutlined } from "@ant-design/icons";
import aplod from "../../assets/images/upload-image.svg";
import Main from "../../components/layout/Main";
import { useSettings } from "../../context/SettingsContext";
import { Severty, ShowToast } from "../../helper/toast";

const { Dragger } = Upload;

function FeedbackIndex() {
  const { submitFeedback, isLoading } = useSettings();
  const [fileError, setFileError] = useState(null);
  const [form] = Form.useForm();

  const submitHandler = async (values) => {
    try {
      const image = values.image?.fileList?.[0]?.originFileObj || null;
      const payload = {
        category: values.category,
        subject: values.subject,
        description: values.description,
        acknowledgement: values.agreement,
        image,
      };
      if (fileError) {
        return;
      }
      const response = await submitFeedback(payload);
      if (response.success) {
        ShowToast("Feedback submitted successfully!", Severty.SUCCESS);
        form.resetFields();
      }
    } catch (error) {
      console.warn("Failed to submit feedback. Please try again.");
    }
  };

  const beforeUpload = (file) => {
    const isValidType = ["image/jpeg", "image/png", "image/jpg"].includes(
      file.type
    );

    if (!isValidType) {
      setFileError("Invalid file type! Only JPG and PNG are allowed.");
      return Upload.LIST_IGNORE; // Prevent file from being added
    }

    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      setFileError("Image must be smaller than 5MB!");
      return Upload.LIST_IGNORE;
    }

    setFileError(null);
    return false; // prevent automatic upload (manual control)
  };

  return (
    <section>
      <div className="active-main-div active-main-div_main feadback-main-container">
        <div className="active-heading-div">
          <h1>Submit Feedback</h1>
          <p>
            We value your thoughts. Please share your feedback to help us improve your experience.
          </p>
        </div>
        <div className="form-container-submit-feedback">
          <Form
            form={form}
            className="form-main"
            layout="vertical"
            onFinish={submitHandler}
          >
            <Form.Item
              className="item"
              label="Category"
              name="category"
              rules={[{ required: true, message: "Please select a category" }]}
            >
              <Select
                className="Suggestion-dropdown"
                placeholder="Select a category"
              >
                <Select.Option value="Bug Report">Bug Report</Select.Option>
                <Select.Option value="Feature Request">
                  Feature Request
                </Select.Option>
                <Select.Option value="General Feedback">
                  General Feedback
                </Select.Option>
                <Select.Option value="Complaint">Complaint</Select.Option>
                <Select.Option value="Other">Other</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              className="item"
              label="Subject"
              name="subject"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (!value || !value.trim()) {
                      return Promise.reject(new Error("Subject is required"));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter subject" />
            </Form.Item>

            <Form.Item
              className="item"
              label="Description"
              name="description"
              rules={[
                {
                  required: true,
                  validator: (_, value) => {
                    if (!value || !value.trim()) {
                      return Promise.reject(
                        new Error("Please enter description")
                      );
                    }
                    if (value.trim().length < 10) {
                      return Promise.reject(
                        new Error("Description must be at least 10 characters")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <TextArea rows={4} placeholder="Describe your feedback..." />
            </Form.Item>

            <Form.Item
              className="item"
              label="Attach Image (Optional)"
              name="image"
              validateStatus={fileError ? "error" : ""}
              help={fileError} // Inline error message
            >
              <Dragger
                beforeUpload={beforeUpload}
                accept=".png,.jpg,.jpeg"
                maxCount={1}
                className="dragger-main"
              >
                <img src={aplod} alt="img" />
                <p>Click to upload or drag and drop</p>
                <p>PNG, JPG up to 5MB</p>
              </Dragger>
            </Form.Item>

            <Form.Item
              name="agreement"
              valuePropName="checked"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(new Error("You must accept this")),
                },
              ]}
            >
              <Checkbox>
                I understand that this submission will be reviewed by admins and
                may require follow-up
              </Checkbox>
            </Form.Item>

            <Button
              htmlType="submit"
              className="Accept-btn"
              loading={isLoading}
            >
              Submit Feedback
            </Button>
          </Form>
        </div>
      </div>
    </section>
  );
}

export default FeedbackIndex;
